import "./About.css"
import image1 from "../img/child-swimming-in-pool_70ec5dc15b0cc256b31d1009d5badbbc.jpg"
export default function About(){
    return(
        <div>
           <section className="about">
            <h1>درباره مربی شنا در تبریز</h1>
            <div className="about-box">
                <p>
                من مربی رسمی شنا در تبریز هستم با سابقه آموزش کودکان و بزرگسالان.
                هدف من آموزش ایمن، اصولی و لذت‌بخش شنا برای تمامی سنین است.
                اگر به دنبال بهترین مربی شنا در تبریز هستید، کلاس‌های ما مناسب شماست.
                </p>
                <img src={image1}></img>
            </div>
            </section> 
        </div>
    )
}